import { useDispatch } from "react-redux";
import { Icon } from "../icons/Icon";

import { hideModal } from "../../redux/actions/modalActions";
import { isScreenMobile } from "../../utils/UIFunctions";
import LeftContent from "../checkout/LeftContent";
import RightContent from "../checkout/RightContent";

const CheckoutModal = () => {
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(hideModal());
  };

  return (
    <div className="u-br--small o-modal__container">
      <div className="o-modal--content-centered u-modal--content-bottom--mobile u-w-all u-relative u-h--100vh--desktop u-overflow--scroll-y--mobile u-h-max--100vh--mobile">
        <button
          className="u-absolute u-top--18 u-right--18"
          aria-label="Close checkout modal"
          onClick={handleClose}
        >
          <Icon
            id="clear"
            stroke={isScreenMobile() ? "white" : "black"}
            size="s"
          />
        </button>

        <div className="u-flex u-justify-between u-h--100vh--desktop u-flex-column--mobile">
          <LeftContent />
          <RightContent />
        </div>
      </div>
    </div>
  );
};

export default CheckoutModal;
